import { render, staticRenderFns } from "./StepsCard.vue?vue&type=template&id=1f307f7a&scoped=true&"
import script from "./StepsCard.vue?vue&type=script&lang=js&"
export * from "./StepsCard.vue?vue&type=script&lang=js&"
import style0 from "./StepsCard.vue?vue&type=style&index=0&id=1f307f7a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f307f7a",
  null
  
)

export default component.exports